import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'risk-profil-third-part-form',
    templateUrl: './risk-profil-third-part-form.component.html',
    styleUrls: ['./risk-profil-third-part-form.component.scss'],
    standalone: false
})
export class RiskProfilThirdPartFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  viewerOpen = false;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
